import { mapGetters, mapActions } from 'vuex'

import headers from './headers'
import salon_headers from './salon_headers'
import maker_headers from './maker_headers'
import { DisplaySwitchButton } from '@/components/items'

import ProductTable from './ProductTable'

export default {
  components: {
    DisplaySwitchButton,
    ProductTable
  },
  props: {
    isEditPage: { default: false },
    selectCurrency: {
      type: Object,
      require: true
    },
    search: {}
  },
  data: () => ({
    openPanelIndex: [],
    groupNames: [],
    pageProductList: [],
    headers: headers.headers,

    productList: [],
    productListData: [],
    editProductData: {},

    errDialog: false
  }),
  async created() {
    await this.init()
  },
  methods: {
    ...mapActions('Product', ['getProductListFromApi']),
    ...mapGetters('Product', ['getProductListFromState']),

    ...mapActions('Supplier', ['getSuppliersFromApi']),
    ...mapGetters('Supplier', ['getSuppliersFromState']),

    ...mapGetters('User', ['isSalonAccount', 'isMakerAccount']),

    async init() {
      this.initHeaders()
      await this.createProductListData()
      this.setGroupNames()
    },
    initHeaders() {
      if (this.isSalonAccount()) {
        this.headers = salon_headers.headers
      } else if (this.isMakerAccount()) {
        this.headers = maker_headers.headers
      } else {
        this.headers = headers.headers
      }
    },
    getSupplierName(id) {
      const supplier = this.getSuppliersFromState().find(
        (ele) => ele.supplierId === id
      )
      return supplier ? supplier.name : this.$t('common.common_unknown')
    },

    getSupplierIsEnabled(id) {
      const supplier = this.getSuppliersFromState().find(
        (ele) => ele.supplierId === id
      )
      return supplier.isEnabled
    },

    async createProductListData() {
      const supplierId = null
      await this.getProductListFromApi()
      const productList = this.getProductListFromState().filter((ele) => {
        const name = ele.nameJp + '' + ele.nameCn
        const nameFilter = this.search.keyword
          ? name.includes(this.search.keyword)
          : true

        const categoryFilter = this.search.category
          ? this.search.category === ele.categoryId
          : true

        const productIsEnabledFilter = this.search.isEnabled
          ? ele.isEnabled === 1
          : true

        const supplierIsEnabledFilter = this.search.isEnabled
          ? this.getSupplierIsEnabled(ele.supplierId)
          : true

        return (
          nameFilter &&
          categoryFilter &&
          productIsEnabledFilter &&
          supplierIsEnabledFilter
        )
      })

      this.productList = productList

      await this.getSuppliersFromApi()
      this.pageProductList = productList.map((ele) => {
        ele.supplierName = this.getSupplierName(ele.supplierId)
        // ソート用の値を追加
        // 商品名
        ele.productInfo = ele.nameJp + ele.nameCn
        return ele
      })
      this.productListData = productList.map((ele) => {
        return {
          ...ele,
          productId: ele.productId,
          invalid: false,
          supplierId: ele.supplierId
        }
      })
    },

    isName(header, name) {
      return header.value === name
    },

    setGroupNames() {
      const productListTmp = [...this.productList]

      this.groupNames = productListTmp
        .sort((a, b) => {
          if (a.supplierId < b.supplierId) return -1
          if (a.supplierId > b.supplierId) return 1
          return 0
        })
        .reduce((result, current) => {
          var element = result.find((p) => p.groupId === current.supplierId)
          if (!element) {
            result.push({
              groupId: current.supplierId,
              open: false,
              index: result.length
            })
          }
          return result
        }, [])
    },
    isOpenPanelOpen(id) {
      const group = this.groupNames.find((p) => p.groupId === id)
      return group ? group.open : false
    },

    setGroupNamesOpen(newVal) {
      this.groupNames = this.groupNames.map((data, index) => {
        data.open = newVal.find((val) => val === data.index) !== undefined
        return data
      })
    },
    edit(editProductData) {
      this.$emit('edit', editProductData)
    }
  },
  watch: {
    openPanelIndex: function (val) {
      this.setGroupNamesOpen(val)
    },
    search: {
      deep: true,
      handler(newVal, oldVal) {
        this.init()
      }
    }
  }
}
